export interface AlertLocationDraft {
  label: string;
  latitude: number;
  longitude: number;
  radiusKm: number;
}

export function readAlertLocationDraft(params: URLSearchParams): AlertLocationDraft | null {
  const label = (params.get('location') || '').trim().slice(0, 160);
  const rawLatitude = params.get('lat');
  const rawLongitude = params.get('lng');
  if (!label || !rawLatitude?.trim() || !rawLongitude?.trim()) return null;
  const latitude = Number(rawLatitude);
  const longitude = Number(rawLongitude);
  const radiusKm = params.has('radius') ? Number(params.get('radius')) : 0.5;
  if (!Number.isFinite(latitude) || latitude < -90 || latitude > 90
    || !Number.isFinite(longitude) || longitude < -180 || longitude > 180
    || !Number.isFinite(radiusKm) || radiusKm < 0.1 || radiusKm > 2) return null;
  return { label, latitude, longitude, radiusKm };
}

export function buildAlertLocationLink(location: Omit<AlertLocationDraft, 'radiusKm'>) {
  const params = new URLSearchParams({
    location: location.label, lat: String(location.latitude), lng: String(location.longitude), radius: '0.5',
  });
  return `/planning-alerts?${params}`;
}
